(() => {
  function mount(scope=document){
    scope.querySelectorAll('[data-bf-countdown]').forEach(timer=>{
      if(timer.dataset.initialized)return;
      timer.dataset.initialized='true';
      const end=Date.parse(timer.dataset.endsAt);
      if(!Number.isFinite(end)){
        timer.hidden=true;
        if(window.Shopify?.designMode){timer.hidden=false;timer.querySelector('[data-countdown-note]').textContent='Check the sale end date (YYYY-MM-DD) and time (HH:MM) in Theme settings → Black Friday countdown.';timer.querySelector('.bf-clock').hidden=true;}
        return;
      }
      let interval;
      const tick=()=>{
        if(!timer.isConnected){clearInterval(interval);return;}
        const remaining=Math.max(0,Math.ceil((end-Date.now())/1000));
        const values={days:Math.floor(remaining/86400),hours:Math.floor(remaining%86400/3600),minutes:Math.floor(remaining%3600/60),seconds:remaining%60};
        Object.entries(values).forEach(([key,value])=>timer.querySelector(`[data-${key}]`).textContent=String(value).padStart(2,'0'));
        if(!remaining){timer.dataset.expired='true';timer.querySelector('.bf-countdown-copy>strong').textContent='THIS BLACK FRIDAY OFFER HAS ENDED';timer.querySelector('[data-countdown-note]').textContent='Visit your cart for current prices.';timer.querySelector('.bf-countdown-cta').hidden=true;clearInterval(interval);}
      };
      tick();if(end>Date.now())interval=setInterval(tick,1000);
    });
  }
  mount();document.addEventListener('shopify:section:load',event=>mount(event.target));
})();
